"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.hydrate = exports.preload = exports.getPreloadStrategy = exports.getElrondPreloadDataUpdates = exports.setElrondPreloadData = exports.getCurrentElrondPreloadData = void 0;
var rxjs_1 = require("rxjs");
var logs_1 = require("@ledgerhq/logs");
var api_1 = require("./api");
var PRELOAD_MAX_AGE = 30 * 60 * 1000; // 30 minutes
var currentPreloadedData = {
    validators: []
};
function fromHydrateValidator(validatorRaw) {
    return {
        contract: validatorRaw.contract,
        owner: validatorRaw.owner,
        serviceFee: validatorRaw.serviceFee,
        maxDelegationCap: validatorRaw.maxDelegationCap,
        initialOwnerFunds: validatorRaw.initialOwnerFunds,
        totalActiveStake: validatorRaw.totalActiveStake,
        totalUnstaked: validatorRaw.totalUnstaked,
        maxDelegateAmountAllowed: validatorRaw.maxDelegateAmountAllowed,
        apr: validatorRaw.apr,
        explorerURL: validatorRaw.explorerURL,
        address: validatorRaw.address,
        aprValue: Number(validatorRaw.aprValue),
        automaticActivation: !!validatorRaw.automaticActivation,
        changeableServiceFee: !!validatorRaw.changeableServiceFee,
        checkCapOnRedelegate: !!validatorRaw.checkCapOnRedelegate,
        createdNonce: Number(validatorRaw.createdNonce),
        featured: !!validatorRaw.featured,
        numNodes: Number(validatorRaw.numNodes),
        numUsers: Number(validatorRaw.numUsers),
        ownerBelowRequiredBalanceThreshold: !!validatorRaw.ownerBelowRequiredBalanceThreshold,
        unBondPeriod: Number(validatorRaw.unBondPeriod),
        withDelegationCap: !!validatorRaw.withDelegationCap,
        disabled: !!validatorRaw.disabled,
        identity: {
            key: validatorRaw.identity.key,
            name: validatorRaw.identity.name,
            avatar: validatorRaw.identity.avatar,
            description: validatorRaw.identity.description,
            location: validatorRaw.identity.location === null ? null : validatorRaw.location,
            twitter: validatorRaw.identity.twitter,
            url: validatorRaw.identity.url
        }
    };
}
function fromHydratePreloadData(data) {
    var validators = [];
    if (typeof data === "object" && data) {
        if (Array.isArray(data.validators)) {
            validators = data.validators.map(fromHydrateValidator);
        }
    }
    return {
        validators: validators
    };
}
var updates = new rxjs_1.Subject();
function getCurrentElrondPreloadData() {
    return currentPreloadedData;
}
exports.getCurrentElrondPreloadData = getCurrentElrondPreloadData;
function setElrondPreloadData(data) {
    if (data === currentPreloadedData)
        return;
    currentPreloadedData = data;
    updates.next(data);
}
exports.setElrondPreloadData = setElrondPreloadData;
function getElrondPreloadDataUpdates() {
    return updates.asObservable();
}
exports.getElrondPreloadDataUpdates = getElrondPreloadDataUpdates;
var getPreloadStrategy = function () {
    return {
        preloadMaxAge: PRELOAD_MAX_AGE
    };
};
exports.getPreloadStrategy = getPreloadStrategy;
var preload = function () { return __awaiter(void 0, void 0, void 0, function () {
    var validators;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                (0, logs_1.log)("elrond/preload", "preloading elrond data...");
                return [4 /*yield*/, (0, api_1.getProviders)()];
            case 1:
                validators = (_a.sent()) || [];
                return [2 /*return*/, {
                        validators: validators
                    }];
        }
    });
}); };
exports.preload = preload;
var hydrate = function (data) {
    var hydrated = fromHydratePreloadData(data);
    (0, logs_1.log)("elrond/preload", "hydrated ".concat(hydrated.validators.length, " elrond validators"));
    setElrondPreloadData(hydrated);
};
exports.hydrate = hydrate;
//# sourceMappingURL=preload.js.map